module.exports = __webpack_public_path__ + "static/img/bgimg2-1.e0ce73b5.png";